import { render } from "./AdminAppearance.vue?vue&type=template&id=53a75d34&scoped=true"
import script from "./AdminAppearance.vue?vue&type=script&lang=js"
export * from "./AdminAppearance.vue?vue&type=script&lang=js"

import "./AdminAppearance.vue?vue&type=style&index=0&id=53a75d34&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a75d34"]])

export default __exports__